import classNames from 'classnames'
import { ReactElement } from 'react'

type Props = {
  text: string
  className?: string
}

export function DateDivider({ text, className }: Props): ReactElement {
  return (
    <div className={classNames(`flex items-center justify-center`, className)}>
      <span className="rounded px-1.5 py-0.5 text-center text-xs font-semibold leading-5 text-default">{text}</span>
    </div>
  )
}
